import React, { createRef, useEffect, useState } from "react";
import { isObjectEmpty } from "../../assets/Js/isObjectEmpty";
import { imageRegex } from "../../assets/Js/regex";
import style from "./UploadFile.module.css";

export default function UploadFile({ defaultImage, setGroupProfileImage }) {
  const [isImageFormatright, setImageFormatRight] = useState(false);
  const [selectedImage, setSelectedImage] = useState({});
  const [isImageSelected, setIsImageSelected] = useState(false);
  const ImageRef = createRef();

  useEffect(() => {
    setImageFormatRight(true);
    setSelectedImage(defaultImage ? defaultImage : {});
    setIsImageSelected(defaultImage ? true : false);
  }, []);

  const selectImage = (e) => {
    let _image = e.target.files[0];
    setIsImageSelected(true);

    if (imageRegex.test(_image.name)) {
      setSelectedImage(_image);
      setGroupProfileImage(_image);
      setImageFormatRight(true);
    } else {
      setImageFormatRight(false);
    }
    ImageRef.current.value = "";
  };

  const unSelectImage = () => {
    ImageRef.current.value = "";
    setIsImageSelected(false);
    setSelectedImage({});
    setGroupProfileImage({});
  };

  return (
    <div>
      <div>
        {!isImageFormatright && isImageSelected && (
          <div className="text-danger">
            Supported Formats gif, jpg, jpeg, png
          </div>
        )}
        <div
          className={`custom-file mt-2 rounded primaryBtn ${style.imageUploadBox}`}
        >
          <div>
            <input
              ref={ImageRef}
              type="file"
              className="custom-file-input"
              id="file"
              accept="image/mp4,image/x-m4v,image/*"
              onChange={selectImage}
            />
          </div>
          <div className={`${style.imageUploadBoxContent}`}>
            {isImageFormatright && isImageSelected ? (
              <>
                <div className="d-flex align-items-center justify-content-between w-100">
                  <div className="d-flex align-items-center">
                    <div className="iconBgPrimaryInverse">
                      <i className={`mdi mdi-check iconBgPrimaryInverse`}></i>
                    </div>
                    <span className="m-0 p-2">Selected</span>
                  </div>
                  <div
                    className={style.unSelectimageBtn}
                    onClick={unSelectImage}
                  >
                    <i className="mdi mdi-close"></i>
                  </div>
                </div>
              </>
            ) : (
              <div className="d-flex align-items-center">
                <div className="iconBgPrimaryInverse">
                  <i className="mdi mdi-upload"></i>
                </div>
                <span className="m-0 p-2">Select Image</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
